export default "{\n    \"activeCount_other\": \"{{count}} habilidades activas\",\n    \"activeCount_one\": \"{{count}} habilidad activa\"\n}\n"